import React, { useEffect } from 'react';
import { ArrivalDateOnboarding as View } from '@views';
import { trackEvent } from '@utils/mixpanel';
import { useLocation } from 'react-router-dom';

const ArrivalDateOnboarding = () => {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = 'Mindspace: Arrival Date';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Arrival Date - Onboarding',
    });
  }, []);

  return <View direction={location?.state?.direction} />;
};

export default ArrivalDateOnboarding;
